import { useDispatch, useSelector } from "react-redux";
import { IStore, State } from "../../DataTypes/storeTypes";
import { updateState } from "../../Actions/actions";
import { Button } from "@powerdiary/components-library/lib";

export const NewClient = () => {
    const { newUsersCanRegister } = useSelector((state: IStore) => state.initialSettings.organisationInfo);
    const dispatch = useDispatch();

    if (!newUsersCanRegister) return null;

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <label className="col-form-label">First time on our client portal?</label>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Button
                        variant="contained"
                        size="large"
                        className="btn-block"
                        onClick={() => dispatch(updateState(State.Register))}
                    >
                        Register Here
                    </Button>
                </div>
            </div>
        </>
    );
};
